<template>
  <v-row
      no-gutters
      style="height: 100%;"
  >
    <v-col cols="8">
      <v-card
          v-if="(!getDivisaoQuadroAtualLoop(1) || !getDivisaoQuadroAtualLoop(1).componenteTipo)
            && (exibindoEm == 'selecionaLayout' || exibindoEm == 'areaEdicao')"
          style="border: 2px grey dashed"
          class="fill-height"
      >
        <v-card-text
            justify="center"
        >
          <p class="text-h5" align="center">
            Layout tipo 3
          </p>
          <div v-if="exibindoEm == 'areaEdicao'">
            <p
                class="text-h6"
                align="center"
            >
              Adicione um componente clicando no ícone abaixo.
            </p>

            <SelecionaComponente
                :divisao-layout=1
            ></SelecionaComponente>
          </div>
        </v-card-text>
      </v-card>
      <div
          :id="`scrollContainer_${getDivisaoQuadroAtualLoop(1).quadroIndex}_1`"
          v-if="getDivisaoQuadroAtualLoop(1) && getDivisaoQuadroAtualLoop(1).componenteTipo"
          @mousedown="setDivisaoNumeroEmEdicao(1)"
          :class="($store.state.timelineStore.layoutDivisaoNumeroEmEdicao == 1 && exibindoEm != 'player' ? 'divisaoEmEdicaozzz' : '')"
          :style="{height: `${$store.state.timelineMainContainerSize.h}px`, overflowY: 'scroll'}"
      >
        <TabelaPreco
            v-if="getDivisaoQuadroAtualLoop(1) && getDivisaoQuadroAtualLoop(1).componenteTipo == 'tabela-preco'"
            :divisao-quadro-atual-loop=getDivisaoQuadroAtualLoop(1)
        ></TabelaPreco>

        <Cartaz
            v-if="getDivisaoQuadroAtualLoop(1) && getDivisaoQuadroAtualLoop(1).componenteTipo == 'cartaz'"
            :divisao-quadro-atual-loop=getDivisaoQuadroAtualLoop(1)
            :exibindo-em="exibindoEm"
        ></Cartaz>

      </div>
    </v-col>

    <v-col cols="4">
      <v-row
          no-gutters
          style="height: 50%;"
      >
        <v-col cols="12">
          <v-card
              v-if="(!getDivisaoQuadroAtualLoop(2) || !getDivisaoQuadroAtualLoop(2).componenteTipo)
            && (exibindoEm == 'selecionaLayout' || exibindoEm == 'areaEdicao')"
              style="border: 2px grey dashed"
              class="fill-height"
          >
            <v-card-text
                justify="center"
            >
              <p class="text-h5" align="center">
                Layout tipo 3
              </p>
              <div v-if="exibindoEm == 'areaEdicao'">
                <p
                    class="text-h6"
                    align="center"
                >
                  Adicione um componente clicando no ícone abaixo.
                </p>

                <SelecionaComponente
                    :divisao-layout=2
                ></SelecionaComponente>
              </div>
            </v-card-text>
          </v-card>
          <div
              :id="`scrollContainer_${getDivisaoQuadroAtualLoop(2).quadroIndex}_2`"
              v-if="getDivisaoQuadroAtualLoop(2) && getDivisaoQuadroAtualLoop(2).componenteTipo"
              @mousedown="setDivisaoNumeroEmEdicao(2)"
              :class="($store.state.timelineStore.layoutDivisaoNumeroEmEdicao == 2 && exibindoEm != 'player' ? 'divisaoEmEdicaozzz' : '')"
              :style="{height: `${$store.state.timelineMainContainerSize.h/2}px`, overflowY: 'scroll'}"
          >
            <TabelaPreco
                v-if="getDivisaoQuadroAtualLoop(2) && getDivisaoQuadroAtualLoop(2).componenteTipo == 'tabela-preco'"
                :divisao-quadro-atual-loop=getDivisaoQuadroAtualLoop(2)
            ></TabelaPreco>

            <Cartaz
                v-if="getDivisaoQuadroAtualLoop(2) && getDivisaoQuadroAtualLoop(2).componenteTipo == 'cartaz'"
                :divisao-quadro-atual-loop=getDivisaoQuadroAtualLoop(2)
                :exibindo-em="exibindoEm"
            ></Cartaz>

          </div>
        </v-col>
      </v-row>
      <v-row
          no-gutters
          style="height: 50%;"
      >
        <v-col cols="12">
          <v-card
              v-if="(!getDivisaoQuadroAtualLoop(3) || !getDivisaoQuadroAtualLoop(3).componenteTipo)
            && (exibindoEm == 'selecionaLayout' || exibindoEm == 'areaEdicao')"
              style="border: 2px grey dashed"
              class="fill-height"
          >
            <v-card-text
                justify="center"
            >
              <p class="text-h5" align="center">
                Layout tipo 3
              </p>
              <div v-if="exibindoEm == 'areaEdicao'">
                <p
                    class="text-h6"
                    align="center"
                >
                  Adicione um componente clicando no ícone abaixo.
                </p>

                <SelecionaComponente
                    :divisao-layout=3
                ></SelecionaComponente>
              </div>
            </v-card-text>
          </v-card>
          <div
              :id="`scrollContainer_${getDivisaoQuadroAtualLoop(3).quadroIndex}_3`"
              v-if="getDivisaoQuadroAtualLoop(3) && getDivisaoQuadroAtualLoop(3).componenteTipo"
              @mousedown="setDivisaoNumeroEmEdicao(3)"
              :class="($store.state.timelineStore.layoutDivisaoNumeroEmEdicao == 3 && exibindoEm != 'player' ? 'divisaoEmEdicaozzz' : '')"
              :style="{height: `${$store.state.timelineMainContainerSize.h/2}px`, overflowY: 'scroll'}"
          >
            <TabelaPreco
                v-if="getDivisaoQuadroAtualLoop(3) && getDivisaoQuadroAtualLoop(3).componenteTipo == 'tabela-preco'"
                :divisao-quadro-atual-loop=getDivisaoQuadroAtualLoop(3)
            ></TabelaPreco>

            <Cartaz
                v-if="getDivisaoQuadroAtualLoop(3) && getDivisaoQuadroAtualLoop(3).componenteTipo == 'cartaz'"
                :divisao-quadro-atual-loop=getDivisaoQuadroAtualLoop(3)
                :exibindo-em="exibindoEm"
            ></Cartaz>

          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import SelecionaComponente from "../components/SelecionaComponente";
import TabelaPreco from "../components/TabelaPreco";
import Cartaz from "../components/Cartaz";
import {timelineMixin} from "../timelineMixin";

export default {
  name: "layout3",
  components: {Cartaz, TabelaPreco, SelecionaComponente},
  data: () => ({
    layoutTipo: 3,
  }),

  mixins: [timelineMixin],

  // created(){
  //   this.$nextTick(() => {
  //     this.$vuetify.goTo(9999, {
  //       container: this.$refs.caraio,
  //       // container: window.document.getElementById(`scrollContainer_${this.getDivisaoQuadroAtualLoop(1).quadroIndex}_1`),
  //       duration: 1000,
  //       offset: 0,
  //       easing: 'linear',//easeInOutQuad
  //     });
  //   })
  // },

  mounted(){
    this.$nextTick(() => {
      setTimeout(() => {
        this.$vuetify.goTo(9999, {
          container: `#scrollContainer_${this.getDivisaoQuadroAtualLoop(1).quadroIndex}_1`,
          duration: 500000,
          offset: 0,
          easing: 'linear',//easeInOutQuad
        });

        this.$vuetify.goTo(9999, {
          container: `#scrollContainer_${this.getDivisaoQuadroAtualLoop(2).quadroIndex}_2`,
          duration: 500000,
          offset: 0,
          easing: 'linear',//easeInOutQuad
        });

        this.$vuetify.goTo(9999, {
          container: `#scrollContainer_${this.getDivisaoQuadroAtualLoop(3).quadroIndex}_3`,
          duration: 500000,
          offset: 0,
          easing: 'linear',//easeInOutQuad
        });

      }, 6000);
    });


    // this.scrollIntervalStart(`scrollContainer_${this.getDivisaoQuadroAtualLoop(1).quadroIndex}_1`);
    //
    // setTimeout(()=>{
    //   this.scrollIntervalStart(`scrollContainer_${this.getDivisaoQuadroAtualLoop(2).quadroIndex}_2`);
    // },1500);

    // setTimeout(()=>{
    //   this.scrollIntervalStart(`scrollContainer_${this.getDivisaoQuadroAtualLoop(3).quadroIndex}_3`);
    // },2500);
  },

  watch: {
    currentSlideIndex: {
      handler() {
        this.$vuetify.goTo(9999, {
          container: `#scrollContainer_${this.currentSlideIndex}_1`,
          duration: 500000,
          offset: 0,
          easing: 'linear',//easeInOutQuad
        });

        this.$vuetify.goTo(9999, {
          container: `#scrollContainer_${this.currentSlideIndex}_2`,
          duration: 500000,
          offset: 0,
          easing: 'linear',//easeInOutQuad
        });

        this.$vuetify.goTo(9999, {
          container: `#scrollContainer_${this.currentSlideIndex}_3`,
          duration: 500000,
          offset: 0,
          easing: 'linear',//easeInOutQuad
        });
      },
      // deep: true,
    }
  },

}
</script>

<style scoped>

</style>
